import { setTheme } from "theme/default/setTheme";

export const setColor_ffffff = setTheme(({ theme }) => `color: ${theme.colors.color_ffffff}`);
